import { reinitHeaderNav, closeHeaderMobileNav } from '../template-parts/header/header'

const HEADER_MENU_SELECTORS = [
	'.site-header__nav--left > .site-header__menu',
	'.site-header__nav--right > .site-header__menu',
]

const FOOTER_MENU_SELECTORS = [
	'.footer__social',
	'.footer__legal-menu',
]

const FOOTER_LOGO_SELECTOR = '.footer__col--logo'

const syncMenuHtml = (selector, doc) => {
	const current = document.querySelector(selector)
	const incoming = doc.querySelector(selector)

	if (current && incoming) {
		current.innerHTML = incoming.innerHTML
	}
}

const syncFooterNav = (doc) => {
	FOOTER_MENU_SELECTORS.forEach((selector) => syncMenuHtml(selector, doc))
	syncMenuHtml(FOOTER_LOGO_SELECTOR, doc)
}

/**
 * Sync header and footer menu active/current classes from a fetched document.
 */
export const syncHeaderNav = (doc) => {
	if (!doc) {
		return
	}

	HEADER_MENU_SELECTORS.forEach((selector) => syncMenuHtml(selector, doc))

	const currentMobile = document.querySelectorAll('.site-header__mobile-nav .site-header__menu--mobile')
	const incomingMobile = doc.querySelectorAll('.site-header__mobile-nav .site-header__menu--mobile')

	currentMobile.forEach((menu, index) => {
		if (incomingMobile[index]) {
			menu.innerHTML = incomingMobile[index].innerHTML
		}
	})

	syncFooterNav(doc)

	reinitHeaderNav()
	closeHeaderMobileNav()
}
